export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/tiktok.0769491.svg";